<template>
<!--     <div style="width: 100%">
        <div class="wrapper-swiper-out swiper-cars">
            <div class="swiper-cars swiper-container grid">
                <swiper class="swiper-wrapper" :options="swiperOptionTop" ref="swiperTop">
                    <swiper-slide v-for="(car, key) in swiperItems" :key="key" class="slide">
                        <thumbnail-car-component v-if="car" :product="car" link-target="_blank"></thumbnail-car-component>
                    </swiper-slide>
                </swiper>
            </div>
            <div class="swiper-button-prev swiper-button-prev-featured" slot="button-prev">
                <span class="tx-30 tx-lightgrey-1"><i class="fas fa-chevron-left"></i></span>
            </div>
            <div class="swiper-button-next swiper-button-next-featured" slot="button-next">
                <span class="tx-30 tx-lightgrey-1"><i class="fas fa-chevron-right"></i></span>
            </div>
        </div>
    </div> -->
    <swiper class="swiper" :options="swiperOptionTop" ref="swiperTop">
        <swiper-slide v-for="(car, key) in swiperItems" :key="key" class="slide">
            <thumbnail-car-component v-if="car" :product="car" link-target="_blank"></thumbnail-car-component>
        </swiper-slide>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
    </swiper>
<!--     <swiper class="swiper" :options="swiperOption">
        <swiper-slide>Slide 1</swiper-slide>
        <swiper-slide>Slide 2</swiper-slide>
        <swiper-slide>Slide 3</swiper-slide>
        <swiper-slide>Slide 4</swiper-slide>
        <swiper-slide>Slide 5</swiper-slide>
        <swiper-slide>Slide 6</swiper-slide>
        <swiper-slide>Slide 7</swiper-slide>
        <swiper-slide>Slide 8</swiper-slide>
        <swiper-slide>Slide 9</swiper-slide>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
        <div class="swiper-button-prev swiper-button-prev-featured" slot="button-prev">
            <span class="tx-30 tx-lightgrey-1"><i class="fas fa-chevron-left"></i></span>
        </div>
        <div class="swiper-button-next swiper-button-next-featured" slot="button-next">
            <span class="tx-30 tx-lightgrey-1"><i class="fas fa-chevron-right"></i></span>
        </div>
    </swiper> -->
</template>

<script>
import ThumbnailCarComponent from '../../layout/ThumbnailCarComponent';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';

export default {
    data() {
        return {
            swiperItems: [],
            swiperOptionTop: {
                slidesPerView: 1,
                spaceBetween: 8,
                loop: true,
                // loopFillGroupWithBlank: true,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
                breakpoints: {
                    540: {
                        slidesPerView: 1
                    },
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 16
                    },
                    1280: {
                        slidesPerView: 3,
                        spaceBetween: 29
                    }
                }
            },
            formData: null,
            err: {}
        }
    },
    props: {
        matches: {
            type: Array,
            required: true,
            default() {
                return []
            }
        }
    },
    components: {
        ThumbnailCarComponent,
        Swiper,
        SwiperSlide
    },
    mounted() {
        console.log('Car slider mounted');
        this.swiperItems = this.matches
        this.$refs.swiperTop.$swiper.update()
    },
    watch: {
        matches(newValue) {
            this.swiperItems = newValue
            console.log(this.$refs.swiperTop.$swiper)
            this.$refs.swiperTop.$swiper.update()
        }
    }
}
</script>